type AutosaveFlusher = () => Promise<void>

const flushers = new Set<AutosaveFlusher>()

export function registerCoachAutosaveFlusher(flusher: AutosaveFlusher): () => void {
  flushers.add(flusher)
  return () => flushers.delete(flusher)
}

export async function flushCoachAutosaves(): Promise<void> {
  const results = await Promise.allSettled([...flushers].map((flusher) => flusher()))
  const failed = results.find(
    (result): result is PromiseRejectedResult => result.status === 'rejected',
  )
  if (failed) throw failed.reason
}
